// addPopupNotification.js
'use strict';
import { ADD_LIST_ITEMS, MERGE_OPERATION_DATA } from '../ActionTypes.js';
import addModal from '../action/addModal.js';
import fetchNotificationOembedData from '../action/fetchNotificationOembedData.js';
import logout from '../action/logout.js';
import getModalData from '../selector/getModalData.js';
import getShouldNotificationRePopup from '../selector/getShouldNotificationRePopup.js';
import getIsValidPopupNotification from '../selector/getIsValidPopupNotification.js';
import {
  STATUS_OPENED,
  STATUS_OPENING,
  MODAL_ID_PREFIX,
  NOTIFICATION_CENTER_POPUP_LIST,
  LIST_SELECT_PATH_PREFIX,
  DETAIL_SELECT_PATH_PREFIX,
} from '../resource/popupNotificationConstants.js';

/**
 * Add notification
 * @kind action
 * @param {string} {id} - notification id.
 * @param {string} {position} - notification position.
 * @param {string} {tag} - notification tag.
 * @param {string} {link} - notification link.
 * @param {string} {exp} - notification exp.
 * @param {boolean} {isNotificationCenter} - is notification come from notification center.
 * User click a item in notification center, this notification will be add into NOTIFICATION_CENTER_POPUP_LIST only.
 * So that user can view notification center item in livestream detail.
 * @return {Promise} Action promise.
 */
const addPopupNotification =
  ({ id, position, tag, link, exp, isNotificationCenter }) =>
  async (dispatch, getState) => {
    if (!tag) {
      return;
    }

    if (tag === 'kick-you-out') {
      return dispatch(logout());
    }

    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: [...DETAIL_SELECT_PATH_PREFIX, tag],
        data: {
          id,
          link,
          position: position?.toLowerCase(),
          tag,
          exp,
        },
      },
    });

    await dispatch(fetchNotificationOembedData({ tag }));

    const isValidPopupNotification = getIsValidPopupNotification(
      getState(),
      tag
    );

    if (isValidPopupNotification) {
      dispatch({
        type: ADD_LIST_ITEMS,
        payload: {
          selectPath: isNotificationCenter
            ? NOTIFICATION_CENTER_POPUP_LIST
            : LIST_SELECT_PATH_PREFIX,
          itemIds: [tag],
        },
      });

      const isNotificationOpened = [STATUS_OPENED, STATUS_OPENING].includes(
        getModalData(getState(), tag, 'status')
      );
      const shouldNotificationRePopup = getShouldNotificationRePopup(
        getState(),
        tag
      );

      if (!isNotificationOpened || shouldNotificationRePopup) {
        return dispatch(
          addModal({
            id: `${MODAL_ID_PREFIX}${tag}`,
            isHigherThanAll: true,
            transitionStatus: STATUS_OPENING,
          })
        );
      }
    }
  };

export default addPopupNotification;
